class TokenService {
  getLocalRefreshToken() {
    const userStr = localStorage.getItem("loggedInUser");
    if (!userStr) return undefined;
    const currentUser = JSON.parse(userStr);
    return currentUser?.refreshToken;
  }

  getLocalAccessToken() {
    const userStr = localStorage.getItem("loggedInUser");
    if (!userStr) return undefined;
    const currentUser = JSON.parse(userStr);
    return currentUser?.accessToken;
  }

  updateLocalAccessToken(accessToken, refreshToken, refreshExpiration) {
    const userStr = localStorage.getItem("loggedInUser");
    if (!userStr) return;

    const currentUser = JSON.parse(userStr);
    const updatedUser = {
      ...currentUser,
      accessToken,
      refreshToken,
      refreshExpiration,
    };

    localStorage.setItem("loggedInUser", JSON.stringify(updatedUser));
  }
  getUser() {
    return JSON.parse(localStorage.getItem("loggedInUser"));
  }

  setUser(user) {
    localStorage.setItem("loggedInUser", JSON.stringify(user));
  }
  removeUser() {
    localStorage.removeItem("loggedInUser");
  }
}

const TokenServiceInstance = new TokenService();
export default TokenServiceInstance;
